import React, {useEffect, useState} from 'react';
import ScrollTrigger from "gsap/ScrollTrigger";
import MotionPathPlugin from "gsap/MotionPathPlugin";
import gsap from "gsap";
import Line1 from "@/Components/Front/SVGS/Line1";
import useNormalizedPosition from "@/Hooks/useNormalizedPosition";
import {position} from "tailwindcss/lib/util/dataTypes";
import LineS1 from "@/Components/Front/SVGS/LineS1";

gsap.registerPlugin(ScrollTrigger, MotionPathPlugin);


const GraphS1 = () => {
    const [progress, setProgress] = React.useState(0);
    const [pathLength, setPathLength] = useState();
    const line1Ref = React.useRef(null);


    const [normalizedPosition, setMaxValue, setScrollProgress] = useNormalizedPosition();


    useEffect(() => {


        gsap.timeline({
            defaults: {duration: 1},
            scrollTrigger: {
                trigger: "#line-s-1",
                // markers: {startColor: "white", endColor: "white"},
                scrub: true,
                start: "top center",
                end: "bottom center",
                onUpdate: self => {
                    setProgress(self.progress.toFixed(3));
                    setScrollProgress(self.progress.toFixed(3));
                }

            }
        })

    }, [])

    useEffect(
        () => {
            if (line1Ref.current) {
                const pathLength = line1Ref.current.getTotalLength();

                setPathLength(pathLength)
                setMaxValue(pathLength);
            }
        },
        [line1Ref]
    )
    return (
        <div className={"graph"}>
            <LineS1 ref={line1Ref} normalizedPosition={normalizedPosition} pathLength={pathLength}/>
        </div>

    )
}

export default GraphS1;
